@if (field) {
	<mat-form-field appearance="outline">
		<mat-label [attr.for]="field?.key">{{ field?.label }}</mat-label>
		<mat-select
			[formControlName]="field?.key"
			[multiple]="field?.multiple || false"
			[id]="field?.key"
			(selectionChange)="onSelectionChange($event)"
		>
			@for (opt of field?.options; track opt.key) {
				<mat-option [value]="opt.key">{{ opt.value }}</mat-option>
			}
		</mat-select>
		@if (controlContainer.control?.get(field?.key)?.hasError('required')) {
			<mat-error>Debe completar el campo.</mat-error>
		}
		@if (controlContainer.control?.get(field?.key)?.hasError('valueExists')) {
			<mat-error>
				{{ field?.rules?.valueExists?.errorMessage }}
			</mat-error>
		}
	</mat-form-field>
}
